import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'

export default class Finance {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}finance/`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getStudyModeCodeByProgram(programCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.programfee}/${programCode}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
}
